import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as zones from '../../../zones'
import type { Feature } from '../feature'

/** Loads Zone audiences for the currently selected Tenant. */
export const executeLoadZones = store.effects.create(
  (feature: Feature, api: zones.Api) =>
    feature.actions.loadZones.request.observe().pipe(
      rxjs.switchMap(action =>
        api.list({ tenantId: action.data.tenantId }).pipe(
          rxjs.map(response =>
            feature.actions.loadZones.success.from(action).create({
              request: action.data,
              response,
            }),
          ),
          rxjs.catchError(error =>
            rxjs.of(
              feature.actions.loadZones.error.from(action).create({
                error,
                request: action.data,
              }),
            ),
          ),
        ),
      ),
    ),
)
